import { env } from "@/config/env"

/**
 * Abre a conversa de WhatsApp comercial com uma mensagem pre-preenchida.
 *
 * `planName` muda o texto para citar o plano de interesse — e o unico sinal que
 * o atendimento recebe sobre de qual card o visitante veio.
 */
export function openWhatsApp(planName?: string): void {
  const text = planName
    ? `Olá! Tenho interesse em contratar o plano *${planName}* da DIMPET Saúde Preventiva. Podem me ajudar?`
    : `Olá! Gostaria de conhecer os planos DIMPET Saúde Preventiva. Podem me ajudar?`

  const url = `https://wa.me/${env.whatsappNumber}?text=${encodeURIComponent(text)}`
  window.open(url, "_blank", "noopener,noreferrer")
}
